import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function ErrorCrossIcon(props: Props) {
  const { t } = useLingui()
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{t`Error Cross Icon`}</title>
      <circle cx="12" cy="12.5" r="9" fill="#FF3C3C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0607 12.5001L15.5304 10.0304L14.4697 8.96973L12.0001 11.4394L9.53039 8.96973L8.46973 10.0304L10.9394 12.5001L8.46973 14.9697L9.53039 16.0304L12.0001 13.5607L14.4697 16.0304L15.5304 14.9697L13.0607 12.5001Z"
        fill="white"
      />
    </svg>
  )
}
